import { html } from 'fxjs/es';
import { pipe, map, toArray, join } from '@fxts/core';
import { font } from '@services/MarppleShop/shared/typography/index.ts';
import { preventEscape } from '@services/MarppleShop/shared/util/preventEscape.ts';

export const wrapper = (type, makeHtml, is_mobile) => html`
  <div class="request-of-solution">
    ${is_mobile
      ? ''
      : html`
          <div class="request-of-solution-menu">
            <div class="help_tab">
              <ul>
                <li selected="${type == 'home'}">
                  <a href="/${T.lang}/@/solution">${T('report::서비스 안내')}</a>
                </li>
                <li selected="${type == 'add'}">
                  <a href="/${T.lang}/@/solution/add">${T('report::신고 접수하기')}</a>
                </li>
                <li selected="${type == 'list'}">
                  <a href="/${T.lang}/@/solution/list">${T('report::조회하기')}</a>
                </li>
              </ul>
            </div>
          </div>
        `}
    <div class="request-of-solution-body">${makeHtml}</div>
  </div>
`;

export const fn = (is_mobile) =>
  wrapper(
    'home',
    html`
      <div class="request-of-solution-home">
        ${is_mobile ? html`<h1>${T('report::신고 접수는 PC에서만 가능합니다.')}</h1>` : ''}
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::신고 접수 서비스 안내')}</h2>
          </div>
          ${pipe(
            [
              T('report::마플샵은 크리에이터와 소비자, 저작권 보호를 위해 신고센터를 운영하고 있습니다.'),
              T('report::마플샵은 플랫폼 서비스 제공자로서 크리에이터'),
              T('report::권리 침해 여부에 대한 판단 및 사후 조치에'),
              T('report::마플샵은 신고 접수 서비스 운영을 통해 플랫폼'),
              T('report::당사자 간의 분쟁이 적법한 절차를 통해 해결될 때까지'),
            ],
            map((text) => html`<p class="article__text">${preventEscape(text)}</p>`),
            toArray,
            join(''),
          )}
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::관련기관 홈페이지')}</h2>
            <p class="a2">${T('report::이미지를 클릭 하면, 해당 홈페이지로 이동합니다.')}</p>
          </div>
          <ul class="org-list">
            <li>
              <a href="http://www.police.go.kr/www/security/cyber.jsp" target="_blank"
                ><img
                  class="police-img"
                  src="//image1.marpple.co/files/u_29089/2020/7/original/3109939873ae3490a3242ff2cffbaaa53747808f2938942.png${is_mobile
                    ? ''
                    : '?w=168'}"
                  alt="${T('report::경찰청 사이버안전국')}"
              /></a>
            </li>
            <li>
              <a href="https://www.copyright.or.kr/main.do" target="_blank"
                ><img
                  class="copyright-img"
                  src="//image1.marpple.co/files/u_29089/2020/7/original/311001163084eeadbc86ea0c82f81207a11f50e62089a1a.png${is_mobile
                    ? ''
                    : '?h=34'}"
                  alt="${T('report::한국저작권위원회')}"
              /></a>
            </li>
          </ul>
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::신고 접수 서비스를 접수할 수 있는 대상')}</h2>
          </div>
          ${pipe(
            [
              T('report::① 저작권침해'),
              T('report::② 위조상품 판매'),
              T('report::4 성인 인증 규정 위반'),
              T('report::③ 마플샵 내부 규정 위반'),
            ],
            map((text) => html`<p class="article__text">${preventEscape(text)}</p>`),
            toArray,
            join(''),
          )}
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::신고 접수 시 처리 과정')}</h2>
            <p>${T('report::저작권 침해 / 위조 상품 판매 (상표권·디자인권 침해)')}</p>
          </div>
          <div class="process-img">
            <img
              src="${is_mobile
                ? '//s3.marpple.co/files/u_29089/2025/5/original/마플샵_신고_1_mo.png'
                : '//s3.marpple.co/files/u_29089/2025/5/original/마플샵_신고_1.png'}"
              alt=""
            />
          </div>
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::저작권 침해 신고 접수 시 유의사항')}</h2>
          </div>
          <ul class="article__list">
            ${pipe(
              [
                T('report::저작권침해 신고 접수 시 해당 상품을 판매 중인'),
                T('report::셀러가 저작권자이거나 정당한 권리자임을 증빙'),
                T('report::신고 접수 스레드는 요청자-셀러 간의 합의를 위한 공간'),
                T('report::저작권법 제 103조 제 3항 및 동법 시행령'),
                T('report::재판매된 상품에 대해서는 반복하여 신고 접수를 할 수 없으며'),
              ],
              map(
                (text) => html`
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">${preventEscape(text)}</p>
                  </li>
                `,
              ),
              toArray,
              join(''),
            )}
          </ul>
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::위조상품판매 신고 접수 시 유의사항')}</h2>
          </div>
          <ul class="article__list">
            ${pipe(
              [
                T('report::위조상품에 대한 조치 요청은 상표법 제107조'),
                T('report::상표법 제108조'),
                T('report::위조상품 판매로 인한 조치 시 해당 상품을'),
                T('report::셀러는 위조 상품이 아니라 정당한 상표 등의'),
                T('report::신고 접수 스레드는 요청자-셀러 간의 합의를 위한 공간'),
              ],
              map(
                (text) => html`
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">${preventEscape(text)}</p>
                  </li>
                `,
              ),
              toArray,
              join(''),
            )}
          </ul>
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::성인 인증 규정 위반 신고 접수 시 유의사항')}</h2>
          </div>
          <ul class="article__list">
            ${pipe(
              [
                T('report::성인 인증 규정 위반 신고가 접수될 경우'),
                T('report::신고 내용은 「청소년 보호법」'),
                T('report::타인의 명의로 성인 인증을 하거나 허위 정보로 인증을 진행한 경우'),
                T('report::성인용 상품임에도 불구하고 성인상품 표시를 하지 않거나'),
                T('report::신고 접수 스레드는 요청자-크리에이터 간 합의를 위한 공간이며'),
                T('report::재판매된 상품에 대해서는 반복하여'),
              ],
              map(
                (text) => html`
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">${preventEscape(text)}</p>
                  </li>
                `,
              ),
              toArray,
              join(''),
            )}
          </ul>
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::마플샵 내부 규정 위반')}</h2>
          </div>
          <div class="process-img">
            <img
              src="${is_mobile
                ? '//s3.marpple.co/files/u_29089/2025/5/original/마플샵_신고_2_mo.png'
                : '//s3.marpple.co/files/u_29089/2025/5/original/마플샵_신고_2.png'}"
              alt=""
            />
          </div>
        </div>
        <div class="article ${font('14_regular')}">
          <div class="article__title">
            <h2>${T('report::마플샵 내부 규정 위반 신고 접수 시 유의사항')}</h2>
          </div>
          <ul class="article__list">
            ${pipe(
              [
                T('report::마플샵 내부 규정 위반 신고 접수 시 해당 상품을 판매 중인'),
                T('report::셀러가 내부 규정 위반 사실이 없음을 증명할 수 있는 자료를 첨부한'),
                T('report::14일 이내 답변 등록이 되지 않은 경우와 심사 후 규정 위반'),
              ],
              map(
                (text) => html`
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">${preventEscape(text)}</p>
                  </li>
                `,
              ),
              toArray,
              join(''),
            )}
          </ul>
        </div>
        ${is_mobile
          ? ''
          : html`
              <div class="buttons ${font('16_bold')}">
                <a href="/${T.lang}/@/solution/list"><span>${T('report::조회하기')}</span></a>
                <a href="/${T.lang}/@/solution/add"><span>${T('report::신고 접수하기')}</span></a>
              </div>
            `}
      </div>
    `,
    is_mobile,
  );
